import React from 'react';
import { UncontrolledCarousel } from 'reactstrap';
import { NavLink } from "react-router-dom";


const items = [
  {
    src: <div className="hero">
    <div className="container">
        <div className="row">
            <div className="col-md-6"></div>
            <div className="col-10 col-md-6 text-left">
                {/* <span className="badge badge-about">ABOUT US</span> */}
                <h1 style={{marginTop:120}}>An investment partner you can trust</h1>
                <hr />
                <p>
                Backed by a rich heritage and driven by our ‘Together, we achieve more’ approach, the FSDH brand has become synonymous with trust, innovation, and reliability. 
                </p>
                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink>
                <br /><br /><br /><br />
            </div>
        </div>
    </div>
</div>,
    key: '1'
  },
  {
    src: <div className="hero">
    <div className="container">
        <div className="row">
            <div className="col-md-6"></div>
            <div className="col-10 col-md-6 text-left">
                {/* <span className="badge badge-about">ABOUT US</span> */}
                <h1 style={{marginTop:120}}>2 An investment partner you can trust</h1>
                <hr />
                <p>
                Backed by a rich heritage and driven by our ‘Together, we achieve more’ approach, the FSDH brand has become synonymous with trust, innovation, and reliability. 
                </p>
                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink>
                <br /><br /><br /><br />
            </div>
        </div>
    </div>
</div>,
    key: '2'
  },
  {
    src: <div className="hero">
    <div className="container">
        <div className="row">
            <div className="col-md-6"></div>
            <div className="col-10 col-md-6 text-left">
                {/* <span className="badge badge-about">ABOUT US</span> */}
                <h1 style={{marginTop:120}}>3 An investment partner you can trust</h1>
                <hr />
                <p>
                Backed by a rich heritage and driven by our ‘Together, we achieve more’ approach, the FSDH brand has become synonymous with trust, innovation, and reliability. 
                </p>
                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink>
                <br /><br /><br /><br />
            </div>
        </div>
    </div>
</div>,
    key: '3'
  }
];

const Carousel = () => <UncontrolledCarousel items={items} />;

export default Carousel;